import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { Tabs, Table, Card, Button, Tooltip, Icon, Input, Avatar } from 'antd';

import { buildIOTAFormUri } from 'utils/routes';
import { getIntegrationTypesConstant } from 'utils/general';
import { getIntegratedListings, getIntegratedHotels } from 'utils/apis/integration';
import { guard } from 'utils/general';

import airbnbLogo from 'images/airbnb-logo.png';
import agodaLogo from 'images/agoda-logo-icon.png';
import agodaHomesLogo from 'images/agodahomes-logo-icon.png';
import bookingcomLogo from 'images/booking-logo-icon.png';
import ctripLogo from 'images/ctrip-logo.png';
import expediaLogo from 'images/expedia-logo-icon.png';
import travelokaLogo from 'images/traveloka-logo-icon.png';
import tiketcomLogo from 'images/tiketcom-logo-icon.png';

import OTAStatusIcon from './components/OTAStatusIcon';
import IntegrationCsvModal from './components/IntegrationCsvModal';
import { withAppContext } from 'context/AppContext';
import intl from 'react-intl-universal';

const TabPane = Tabs.TabPane;
const { LISTING_TYPE, HOTEL_TYPE } = getIntegrationTypesConstant();
const DEFAULT_PAGE_SIZE = 10;

class OTAListing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listingOTA: [],
      listingTotal: 0,
      listingPage: 1,
      listingPageSize: DEFAULT_PAGE_SIZE,
      listingUnitSearch: '',
      listingPropertySearch: '',
      listingSortBy: 'unit',
      listingSortOrder: 'ascend',
      hotelOTA: [],
      hotelTotal: 0,
      hotelPage: 1,
      hotelPageSize: DEFAULT_PAGE_SIZE,
      hotelPropertySearch: '',
      hotelSortBy: 'property',
      hotelSortOrder: 'ascend',
      hotelDataFetched: false,
      isListingLoading: true,
      isHotelLoading: false,
      csvModalVisible: false,
      csvModalType: LISTING_TYPE.code
    };

    this.tabChange = this.tabChange.bind(this);
  }

  componentWillMount() {
    this.fetchListingPage(1, DEFAULT_PAGE_SIZE);
  }

  tabChange(activeTab) {
    if (activeTab === 'hotel' && !this.state.hotelDataFetched) {
      this.fetchHotelPage(1, this.state.hotelPageSize);
    }
  }

  fetchListingPage = (
    page,
    pageSize = this.state.listingPageSize,
    {
      unitSearch = this.state.listingUnitSearch,
      propertySearch = this.state.listingPropertySearch,
      sortBy = this.state.listingSortBy,
      sortOrder = this.state.listingSortOrder
    } = {}
  ) => {
    this.setState({ isListingLoading: true });

    return getIntegratedListings({ page, limit: pageSize, unitSearch, propertySearch, sortBy, sortOrder })
      .then(listingRes => {
        const payload = listingRes && listingRes.status === 200 ? listingRes.data : {};
        this.setState({
          listingOTA: payload.listings || [],
          listingTotal: payload.totalCount || 0,
          listingPage: page,
          listingPageSize: pageSize,
          listingUnitSearch: unitSearch || '',
          listingPropertySearch: propertySearch || '',
          listingSortBy: sortBy || 'unit',
          listingSortOrder: sortOrder || 'ascend',
          isListingLoading: false
        });
      })
      .catch(ex => {
        console.log(ex, 'Error occurred when retrieving integrated listings.');
        this.setState({ isListingLoading: false });
      });
  };

  fetchHotelPage = (
    page,
    pageSize = this.state.hotelPageSize,
    { propertySearch = this.state.hotelPropertySearch, sortBy = this.state.hotelSortBy, sortOrder = this.state.hotelSortOrder, all = false } = {}
  ) => {
    this.setState({ isHotelLoading: true });

    return getIntegratedHotels({ page, limit: pageSize, propertySearch, sortBy, sortOrder, all })
      .then(hotelRes => {
        const payload = hotelRes && hotelRes.status === 200 ? hotelRes.data : {};
        this.setState({
          hotelOTA: payload.hotels || [],
          hotelTotal: payload.totalCount || 0,
          hotelPage: all ? 1 : page,
          hotelPageSize: all ? payload.totalCount || pageSize : pageSize,
          hotelPropertySearch: propertySearch || '',
          hotelSortBy: sortBy || 'property',
          hotelSortOrder: sortOrder || 'ascend',
          hotelDataFetched: true,
          isHotelLoading: false
        });
        return payload.hotels || [];
      })
      .catch(ex => {
        console.log(ex, 'Error occurred when retrieving integrated hotels.');
        this.setState({ isHotelLoading: false });
        return [];
      });
  };

  getFilterValue = (filters, key) => {
    const values = filters && filters[key];
    return values && values[0] ? String(values[0]).trim() : '';
  };

  handleListingTableChange = (pagination, filters, sorter) => {
    const unitSearch = this.getFilterValue(filters, 'unit');
    const propertySearch = this.getFilterValue(filters, 'property');
    const sortBy = (sorter && sorter.columnKey) || (sorter && sorter.field) || 'unit';
    const sortOrder = (sorter && sorter.order) || 'ascend';
    const pageSize = pagination.pageSize;
    const filtersChanged = unitSearch !== this.state.listingUnitSearch || propertySearch !== this.state.listingPropertySearch;
    const sortChanged = sortBy !== this.state.listingSortBy || sortOrder !== this.state.listingSortOrder;
    const page = filtersChanged || sortChanged ? 1 : pagination.current;

    this.fetchListingPage(page, pageSize, { unitSearch, propertySearch, sortBy, sortOrder });
  };

  handleHotelTableChange = (pagination, filters, sorter) => {
    const propertySearch = this.getFilterValue(filters, 'property');
    const sortBy = (sorter && sorter.columnKey) || (sorter && sorter.field) || 'property';
    const sortOrder = (sorter && sorter.order) || 'ascend';
    const pageSize = pagination.pageSize;
    const filtersChanged = propertySearch !== this.state.hotelPropertySearch;
    const sortChanged = sortBy !== this.state.hotelSortBy || sortOrder !== this.state.hotelSortOrder;
    const page = filtersChanged || sortChanged ? 1 : pagination.current;

    this.fetchHotelPage(page, pageSize, { propertySearch, sortBy, sortOrder });
  };

  openCsvModal = type => {
    this.setState({ csvModalVisible: true, csvModalType: type });
  };

  closeCsvModal = () => {
    this.setState({ csvModalVisible: false });
  };

  handleSearch = (selectedKeys, confirm) => () => {
    confirm();
  };

  handleReset = clearFilters => () => {
    clearFilters();
  };

  getSelectedFilterValue = selectedKeys => (selectedKeys && selectedKeys[0]) || '';

  renderSearchFilterDropdown = ({ placeholder, name }) => ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div className="custom-filter-dropdown">
      <Input
        ref={ele => (this.searchInput = ele)}
        placeholder={placeholder}
        value={this.getSelectedFilterValue(selectedKeys)}
        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
        onPressEnter={this.handleSearch(selectedKeys, confirm)}
        name={name}
      />
      <Button type="primary" onClick={this.handleSearch(selectedKeys, confirm)}>
        {intl.get('tables.search').d('Search')}
      </Button>{' '}
      <Button onClick={this.handleReset(clearFilters)}>{intl.get('tables.reset').d('Reset')}</Button>
    </div>
  );

  render() {
    const {
      listingOTA,
      listingTotal,
      listingPage,
      listingPageSize,
      listingUnitSearch,
      listingPropertySearch,
      listingSortBy,
      listingSortOrder,
      hotelOTA,
      hotelTotal,
      hotelPage,
      hotelPageSize,
      hotelPropertySearch,
      hotelSortBy,
      hotelSortOrder,
      isListingLoading,
      isHotelLoading,
      csvModalVisible,
      csvModalType
    } = this.state;

    const csvFilters =
      csvModalType === LISTING_TYPE.code
        ? {
            unitSearch: listingUnitSearch,
            propertySearch: listingPropertySearch,
            sortBy: listingSortBy,
            sortOrder: listingSortOrder
          }
        : {
            propertySearch: hotelPropertySearch,
            sortBy: hotelSortBy,
            sortOrder: hotelSortOrder
          };

    const listingColumns = [
      {
        title: intl.get('hostConnect.integration.tableColumns.unit').d('Unit'),
        dataIndex: 'unit',
        key: 'unit',
        sorter: true,
        sortOrder: listingSortBy === 'unit' ? listingSortOrder : false,
        filteredValue: listingUnitSearch ? [listingUnitSearch] : [],
        filterDropdown: this.renderSearchFilterDropdown({
          placeholder: intl.get('tables.unit').d('Search Unit Name'),
          name: 'searchUnitListingIntegration'
        }),
        filterIcon: filtered => <Icon type="search" style={{ color: filtered ? '#00b9c6' : '#aaa' }} />
      },
      {
        title: intl.get('hostConnect.integration.tableColumns.property').d('Property'),
        dataIndex: 'property',
        key: 'property',
        sorter: true,
        sortOrder: listingSortBy === 'property' ? listingSortOrder : false,
        filteredValue: listingPropertySearch ? [listingPropertySearch] : [],
        filterDropdown: this.renderSearchFilterDropdown({
          placeholder: intl.get('tables.property').d('Search Property Name'),
          name: 'searchPropertyListingIntegration'
        }),
        filterIcon: filtered => <Icon type="search" style={{ color: filtered ? '#00b9c6' : '#aaa' }} />
      },
      {
        title: (
          <Tooltip title="Airbnb">
            <Avatar size="small" src={airbnbLogo} />
          </Tooltip>
        ),
        dataIndex: 'airbnb',
        key: 'airbnb',
        width: '100px',
        sorter: true,
        sortOrder: listingSortBy === 'airbnb' ? listingSortOrder : false
      },
      {
        title: (
          <Tooltip title="Agoda Homes">
            <Avatar size="small" src={agodaHomesLogo} />
          </Tooltip>
        ),
        dataIndex: 'agodahomes',
        key: 'agodahomes',
        width: '100px',
        sorter: true,
        sortOrder: listingSortBy === 'agodahomes' ? listingSortOrder : false
      }
    ];
    let listingData = listingOTA
      .filter(lOTA => lOTA.ota.airbnb || lOTA.ota.agodahomes)
      .map(lOTA => {
        return {
          unit: (
            <Link to={buildIOTAFormUri({ propertyId: lOTA.property._id, unitId: lOTA.unit._id, integrationType: LISTING_TYPE.code })}>
              {lOTA.unit.name}
            </Link>
          ),
          property: lOTA.property.name,
          airbnb: lOTA.ota.airbnb ? lOTA.ota.airbnb.status : null,
          agodahomes: lOTA.ota.agodahomes ? lOTA.ota.agodahomes.status : null
        };
      });
    listingData = listingData.map(listingD => {
      return {
        ...listingD,
        airbnb: listingD.airbnb ? (
          listingD.airbnb === 'approved' ? (
            <OTAStatusIcon type="ok" />
          ) : listingD.airbnb === 'pending' || listingD.airbnb === 'new' ? (
            <OTAStatusIcon type="pending" />
          ) : listingD.airbnb === 'error' || listingD.airbnb === 'rejected' ? (
            <OTAStatusIcon type="error" />
          ) : listingD.airbnb === 'pushing' ? (
            <OTAStatusIcon type="pending" tooltip={intl.get('hostConnect.integration.otaStatus.processing').d('System is proccessing')} />
          ) : (
            <OTAStatusIcon type="unknown" />
          )
        ) : (
          <OTAStatusIcon type="nosync" />
        ),
        agodahomes: listingD.agodahomes ? <OTAStatusIcon type="ok" /> : <OTAStatusIcon type="nosync" />
      };
    });

    const propertyColumn = [
      {
        title: intl.get('hostConnect.integration.tableColumns.property').d('Property'),
        dataIndex: 'property',
        key: 'property',
        sorter: true,
        sortOrder: hotelSortBy === 'property' ? hotelSortOrder : false,
        filterDropdown: this.renderSearchFilterDropdown({
          placeholder: intl.get('tables.property').d('Search Property Name'),
          name: 'searchPropertyHotelIntegration'
        }),
        filterIcon: filtered => <Icon type="search" style={{ color: filtered ? '#00b9c6' : '#aaa' }} />,
        filteredValue: hotelPropertySearch ? [hotelPropertySearch] : []
      },
      {
        title: (
          <Tooltip title="Booking.com">
            <Avatar size="small" src={bookingcomLogo} />
          </Tooltip>
        ),
        dataIndex: 'bookingcom',
        key: 'bookingcom',
        width: '100px',
        sorter: true,
        sortOrder: hotelSortBy === 'bookingcom' ? hotelSortOrder : false
      },
      {
        title: (
          <Tooltip title="Expedia">
            <Avatar size="small" src={expediaLogo} />
          </Tooltip>
        ),
        dataIndex: 'expedia',
        key: 'expedia',
        width: '100px',
        sorter: true,
        sortOrder: hotelSortBy === 'expedia' ? hotelSortOrder : false
      },
      {
        title: (
          <Tooltip title="Agoda">
            <Avatar size="small" src={agodaLogo} />
          </Tooltip>
        ),
        dataIndex: 'agoda',
        key: 'agoda',
        width: '100px',
        sorter: true,
        sortOrder: hotelSortBy === 'agoda' ? hotelSortOrder : false
      },
      {
        title: (
          <Tooltip title="Ctrip">
            <Avatar size="small" src={ctripLogo} />
          </Tooltip>
        ),
        dataIndex: 'ctripCM',
        key: 'ctripCM',
        width: '100px',
        sorter: true,
        sortOrder: hotelSortBy === 'ctripCM' ? hotelSortOrder : false
      },
      {
        title: (
          <Tooltip title="Traveloka">
            <Avatar size="small" src={travelokaLogo} />
          </Tooltip>
        ),
        dataIndex: 'traveloka',
        key: 'traveloka',
        width: '100px',
        sorter: true,
        sortOrder: hotelSortBy === 'traveloka' ? hotelSortOrder : false
      },
      {
        title: (
          <Tooltip title="Tiket.com">
            <Avatar size="small" src={tiketcomLogo} />
          </Tooltip>
        ),
        dataIndex: 'tiketcom',
        key: 'tiketcom',
        width: '100px',
        sorter: true,
        sortOrder: hotelSortBy === 'tiketcom' ? hotelSortOrder : false
      },
      {
        title: (
          <Tooltip title="Airbnb">
            <Avatar size="small" src={airbnbLogo} />
          </Tooltip>
        ),
        dataIndex: 'airbnb',
        key: 'airbnb',
        width: '100px',
        sorter: true,
        sortOrder: hotelSortBy === 'airbnb' ? hotelSortOrder : false
      }
    ];

    let propertyData = hotelOTA.map(hOTA => {
      return {
        property: <Link to={buildIOTAFormUri({ propertyId: hOTA.property._id, integrationType: HOTEL_TYPE.code })}>{hOTA.property.name}</Link>,
        ctrip: hOTA.ota.ctrip ? hOTA.ota.ctrip.status : null,
        bookingcom: hOTA.ota.bookingcom ? hOTA.ota.bookingcom.status : null,
        expedia: hOTA.ota.expedia ? hOTA.ota.expedia.status : null,
        agoda: hOTA.ota.agoda ? hOTA.ota.agoda.status : null,
        ctripCM: hOTA.ota.ctripCM ? hOTA.ota.ctripCM.status : null,
        traveloka: hOTA.ota.traveloka ? hOTA.ota.traveloka.status : null,
        tiketcom: hOTA.ota.tiketcom ? hOTA.ota.tiketcom.status : null,
        airbnb: hOTA.ota.airbnb ? hOTA.ota.airbnb.status : null
      };
    });

    propertyData = propertyData
      .filter(p => p.ctrip || p.bookingcom || p.expedia || p.agoda || p.ctripCM || p.traveloka || p.tiketcom || p.airbnb)
      .map(propertyD => {
        return {
          ...propertyD,
          ctrip: propertyD.ctrip ? (
            propertyD.ctrip === 'Active' ? (
              <OTAStatusIcon type="ok" />
            ) : propertyD.ctrip === 'Pending' ? (
              <OTAStatusIcon type="pending" />
            ) : propertyD.ctrip === 'Failed' ? (
              <OTAStatusIcon type="error" />
            ) : (
              <OTAStatusIcon type="unknown" />
            )
          ) : (
            <OTAStatusIcon type="nosync" />
          ),
          bookingcom: propertyD.bookingcom ? (
            propertyD.bookingcom === 'synced' ? (
              <OTAStatusIcon type="ok" />
            ) : propertyD.bookingcom === 'pushing' ? (
              <OTAStatusIcon type="pending" />
            ) : propertyD.bookingcom === 'nobind' ? (
              <OTAStatusIcon type="error" />
            ) : (
              <OTAStatusIcon type="unknown" />
            )
          ) : (
            <OTAStatusIcon type="nosync" />
          ),
          expedia: propertyD.expedia ? (
            propertyD.expedia === 'Synced' ? (
              <OTAStatusIcon type="ok" />
            ) : propertyD.expedia === 'Pending' ? (
              <OTAStatusIcon type="pending" />
            ) : propertyD.expedia === 'Not Synced' ? (
              <OTAStatusIcon type="error" />
            ) : (
              <OTAStatusIcon type="unknown" />
            )
          ) : (
            <OTAStatusIcon type="nosync" />
          ),
          agoda: propertyD.agoda ? <OTAStatusIcon type="ok" /> : <OTAStatusIcon type="nosync" />,
          ctripCM: propertyD.ctripCM ? (
            propertyD.ctripCM === 'synced' ? (
              <OTAStatusIcon type="ok" />
            ) : propertyD.ctripCM === 'nobind' ? (
              <OTAStatusIcon type="nosync" />
            ) : (
              <OTAStatusIcon type="error" />
            )
          ) : (
            <OTAStatusIcon type="nosync" />
          ),
          traveloka: propertyD.traveloka ? (
            propertyD.traveloka === 'synced' ? (
              <OTAStatusIcon type="ok" />
            ) : propertyD.traveloka === 'nobind' ? (
              <OTAStatusIcon type="nosync" />
            ) : (
              <OTAStatusIcon type="error" />
            )
          ) : (
            <OTAStatusIcon type="nosync" />
          ),
          tiketcom: propertyD.tiketcom ? (
            propertyD.tiketcom === 'synced' ? (
              <OTAStatusIcon type="ok" />
            ) : propertyD.traveloka === 'nobind' ? (
              <OTAStatusIcon type="nosync" />
            ) : (
              <OTAStatusIcon type="error" />
            )
          ) : (
            <OTAStatusIcon type="nosync" />
          ),
          airbnb: propertyD.airbnb ? (
            propertyD.airbnb === 'approved' ? (
              <OTAStatusIcon type="ok" />
            ) : propertyD.airbnb === 'pending' || propertyD.airbnb === 'new' ? (
              <OTAStatusIcon type="pending" />
            ) : propertyD.airbnb === 'error' || propertyD.airbnb === 'rejected' ? (
              <OTAStatusIcon type="error" />
            ) : propertyD.airbnb === 'pushing' ? (
              <OTAStatusIcon type="ok" />
            ) : (
              <OTAStatusIcon type="unknown" />
            )
          ) : (
            <OTAStatusIcon type="nosync" />
          )
        };
      });
    return (
      <Card className="list-card">
        <Tabs defaultActiveKey="listing" onChange={this.tabChange}>
          <TabPane tab={intl.get('hostConnect.integration.integrationType.Listing Integration').d('Listing Integration')} key="listing">
            <div className="list-card-control-section">
              <Link to={buildIOTAFormUri()}>
                <Button
                  id="create-button8-listingint"
                  type="primary"
                  style={{ marginTop: 16 }}
                  icon="plus"
                  checkIsAdminReadOnly={this.props.checkIsAdminReadOnly}
                >
                  {intl.get('hostConnect.integration.headerLabels.createIntegrationLabel').d('Create Integration')}
                </Button>
              </Link>
              <Button
                id="csv-button5-listing"
                type="primary"
                icon="download"
                style={{ marginTop: 16, marginLeft: 8 }}
                onClick={() => this.openCsvModal(LISTING_TYPE.code)}
                disabled={this.props.checkIsAdminReadOnly()}
              >
                {intl.get('listings.headerLabels.downloadCSV').d('Download CSV')}
              </Button>
            </div>
            <Table
              scroll={{ x: 1000 }}
              columns={listingColumns}
              dataSource={listingData}
              loading={isListingLoading}
              rowKey={(record, index) => `listing-${index}`}
              pagination={{
                current: listingPage,
                pageSize: listingPageSize,
                total: listingTotal,
                showSizeChanger: true,
                pageSizeOptions: ['10', '25', '50', '100']
              }}
              onChange={this.handleListingTableChange}
            />
          </TabPane>
          <TabPane tab={intl.get('hostConnect.integration.integrationType.Hotel Integration').d('Hotel Integration')} key="hotel">
            <div className="list-card-control-section">
              <Link to={buildIOTAFormUri({ integrationType: HOTEL_TYPE.code })}>
                <Button
                  id="create-button9-hotelint"
                  style={{ marginTop: 16 }}
                  type="primary"
                  icon="plus"
                  checkIsAdminReadOnly={this.props.checkIsAdminReadOnly}
                >
                  {intl.get('hostConnect.integration.headerLabels.addIntegration').d('Add Integration')}
                </Button>
              </Link>
              <Button
                id="csv-button5-hotel"
                type="primary"
                icon="download"
                style={{ marginTop: 16, marginLeft: 8 }}
                onClick={() => this.openCsvModal(HOTEL_TYPE.code)}
                disabled={this.props.checkIsAdminReadOnly()}
              >
                {intl.get('listings.headerLabels.downloadCSV').d('Download CSV')}
              </Button>
            </div>
            <Table
              scroll={{ x: 1000 }}
              columns={propertyColumn}
              dataSource={propertyData}
              loading={isHotelLoading}
              rowKey={(record, index) => `hotel-${index}`}
              pagination={{
                current: hotelPage,
                pageSize: hotelPageSize,
                total: hotelTotal,
                showSizeChanger: true,
                pageSizeOptions: ['10', '25', '50', '100']
              }}
              onChange={this.handleHotelTableChange}
            />
          </TabPane>
        </Tabs>
        <IntegrationCsvModal
          visible={csvModalVisible}
          closeModal={this.closeCsvModal}
          integrationType={csvModalType}
          filters={csvFilters}
          defaultEmail={guard(() => this.props.user.email, '')}
        />
      </Card>
    );
  }
}

export default withRouter(withAppContext(OTAListing));
